import { render } from "./iconMicro.vue?vue&type=template&id=6becc384&scoped=true"
import script from "./iconMicro.vue?vue&type=script&lang=js"
export * from "./iconMicro.vue?vue&type=script&lang=js"

import "./iconMicro.vue?vue&type=style&index=0&id=6becc384&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6becc384"

export default script